<div style="padding: 10%; text-align: center">
  <p>Não foi possível carregar a aplicação. Tente novamente.</p>
  <app-button (click)="reload()">TENTAR NOVAMENTE</app-button>
  <app-button variant="ghost-primary" routerLink="/login">
    VOLTAR AO LOGIN
  </app-button>
</div>
